import React, { PropTypes } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import ScreenHeader from '../Subcomponents/ScreenHeader';
import ScreenInstructions from '../Subcomponents/ScreenInstructions';
import ScreenContainer from '../Subcomponents/ScreenContainer';
import { continueClicked, resetClicked} from '../../../actions/screenAction';

class Error extends React.Component {
  constructor(props) {
    super(props);
    this.reset = this.reset.bind(this);
  }

  continue(event) {
    event.preventDefault();
    this.props.actions.continueClicked(this.props.name);
  }
  reset(event) {
    event.preventDefault();
    this.props.actions.resetClicked(this.props.name);
  }

  render() {
    let textResources = this.props.textResources;
    let values = this.props.values;
    return (
      <ScreenContainer>
        <ScreenHeader title={textResources.HeaderTitle} text={textResources.HeaderText} icon="cross-in-circle.png" iconIsCircle="true" />
        <ScreenInstructions title={textResources.InstructionTitle} text={textResources.InstructionText} />

        <form className="o-pageSection o-pageSection--form">
          <div className="o-buttonContainer">
            <a className="c-Btn c-Btn--primary u-mb6" href="#" onClick={this.reset}>{textResources.ContinueButtonText}</a>
            <a className="c-LinkCancel" href={values.CancelUrl}>{textResources.CancelButtonText}</a>
          </div>
        </form>
      </ScreenContainer>
    );
  }
}

Error.propTypes = {
  name: React.PropTypes.string.isRequired,
  values: React.PropTypes.object.isRequired,
  uiSpec: React.PropTypes.object.isRequired,
  textResources: React.PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({continueClicked, resetClicked}, dispatch)
  };
}

function mapStateToProps(state, ownProps){
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Error);


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Shared/Error.js
 **/